import Chip from '@material-ui/core/Chip'
import { useStyles } from './styles'
export default function StatusButton(props) {
  const classes = useStyles()
  const { color, text, noborder } = props
  return (
    <div className={classes.root}>
      <Chip
        avatar={
          <div
            className={`${classes[props.color]} ${classes.round}`}
            style={{ background: color, marginRight: '5px' }}
          ></div>
        }
        label={text}
        size="small"
        variant="outlined"
        className={classes.chip + (noborder ? ' ' + classes.noborder : '')}
      />
    </div>
  )
}
